import vueRouter from 'vue-router';
import  Vue from 'vue';
import store from "./store";

Vue.use(vueRouter);

const router = new vueRouter({
    mode: "history",
    base: process.env.BASE_URL,




    routes: [
    {
        path: '*',
        redirect: '/error'
    },

    {
        path: '/',
        name: 'home',

        component: () => import('./views/Home.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/auth')
            }
        }
    },

    {
        path: '/pokupka',
        name: 'pokupka',

        component: () => import('./views/Pokupka/Pokupka.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/molho',
        name: 'molho',

        component: () => import('./views/Molho/Molho.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/tovari',
        name: 'tovari',

        component: () => import('./views/Molho/Tovari.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/kharid',
        name: 'kharid',

        component: () => import('./views/Molho/Kharid.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },



    {
        path: '/moving',
        name: 'moving',

        component: () => import('./views/Molho/Moving.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/kassa',
        name: 'kassa',

        component: () => import('./views/Molho/Kassa.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/reports',
        name: 'reports',

        component: () => import('./views/Molho/Reports.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2 ) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/priyom',
        name: 'priyom',

        component: () => import('./views/Molho/PriyomSmena.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },

    {
        path: '/settings',
        name: 'settings',

        component: () => import('./views/Molho/Settings.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2 ) {
                next()
            } else {
                next('/error')
            }
        }
    },



    {
        path: '/spravochniki',
        name: 'spravochniki',

        component: () => import('./views/Spravochnik/Spravochnik.vue'),
        meta:{
            layout: 'main',
            autorization: true
        },
        beforeEnter: (to, from, next) => {
            if (router.app.$session.get('dostup')==1 ||router.app.$session.get('dostup')==2) {
                next()
            } else {
                next('/error')
            }
        }
    },



    {
        path: '/auth',
        name: 'auth',
        meta:{
            layout: 'auth',
            autorization: false
        }
    },
    {
        path: '/forget',
        name: 'forget',
        meta:{
            layout: 'forget',
            autorization: false
        }
    },
    {
        path: '/lock',
        name: 'lock',
        meta:{
            layout: 'lock',
            autorization: false
        }
    },
    {
        path: '/error',
        name: 'error',
        meta:{
            layout: 'error',
            autorization: false
        }
    },
    // {
    //     path: '/spravochnik',
    //     name: 'spravochnik',
    //     children:[
    //         {
    //         path: 'users',
    //         name: 'users',
    //         component: () => import('./views/Spravochnik/Users.vue'),
    //         },
    //         {
    //         path: 'magoza',
    //         name: 'magoza',
    //         component: () => import('./views/Spravochnik/Magoza.vue'),

    //         }


    //     ],
    //     component: () => import('./views/Spravochnik/Spravochnik.vue'),
    //     meta:{
    //         layout: 'main',
    //         autorization: true
    //     },
    //     beforeEnter: (to, from, next) => {
    //         if (router.app.$session.get('dostup')==1 || router.app.$session.get('dostup')==2) {
    //             next()
    //         } else {
    //             next('/auth')
    //         }
    //     }
    // },


]
})


// router.beforeEach( (to, from, next) => {

//     const requiresAuth = to.matched.some(record => record.meta.autorization);

//     if(requiresAuth){
//         next({name: 'auth'});
//     }else{
//          next();
//     }
// });




// export default new vueRouter( {
//      mode: "history",
//         routes

// });



export default router;
